module.exports = __webpack_public_path__ + "img/folder.29dc368a.png";